export { default as ComunicadosAlumnosList } from './Listar';
export { default as VerComunicadoAlumno } from './Ver'
